import React from 'react';
import { useSelector } from 'react-redux';

import { PaymentMethodCard } from '../../components/PaymentMethodCard';
import { PaymentMethodsSection } from '../../components/PaymentMethodsSection';
import { selectAdditionalServices } from '../../selectors/promoInfo';

export const PaymentMethodsContainer = () => {
  const methods = useSelector(selectAdditionalServices);

  return (
    <PaymentMethodsSection cardsLength={methods.length}>
      {methods.map((paymentMethod, i) => (
        <PaymentMethodCard key={i} {...paymentMethod} isFirst={i === 0} />
      ))}
    </PaymentMethodsSection>
  );
};
